import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function FinalCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const imageY = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  return <section ref={sectionRef} id="contact" className="relative min-h-[60vh] flex items-center justify-center overflow-hidden" data-id="element-12">
      {/* Background with Parallax */}
      <motion.div className="absolute inset-0 z-0" style={{
      y: imageY
    }} data-id="element-13">
        <img src="https://cdn.magicpatterns.com/uploads/3CefMm6rGBJY9G2ApxKi7h/mike-curry-cta.png" alt="Man standing on mountain top" className="w-full h-[130%] object-cover object-center" data-id="element-14" />
      </motion.div>
      <div className="absolute inset-0 z-[1] bg-charcoal/50 mix-blend-multiply" data-id="element-15"></div>
      <div className="absolute inset-0 z-[1] bg-black/20" data-id="element-16"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-18">
          <h2 className="font-heading text-5xl md:text-7xl text-white mb-6 leading-tight" data-id="element-19">
            When One Person Heals, <br data-id="element-20" />
            <span className="text-gold" data-id="element-21">
              That Healing Ripples Out Into Everything.
            </span>
          </h2>

          <p className="text-xl text-gray-300 mb-10 font-light" data-id="element-22">
            You don't have to figure this out alone. The first step is a
            conversation.
          </p>

          <a href="#" className="inline-block bg-gold hover:bg-gold-light text-black font-bold text-lg py-4 px-12 rounded-sm uppercase tracking-widest transition-all transform hover:scale-105 shadow-2xl" data-id="element-23">
            Book Your Free Strategy Session
          </a>
        </motion.div>
      </div>
    </section>;
}